import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Archive2022 } from '../ScintillaOfArt/components';
import Sidebar2026 from '../SEWA/components/Sidebar2026/Sidebar2026';


const ScintillaofArt2026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });


    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2026}/home/events-activities/sewa/ScintillaofArt2026/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/sewa/ScintillaofArt2026/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/sewa/ScintillaofArt2026/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/sewa/ScintillaofArt2026/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/sewa/ScintillaofArt2026/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/sewa/ScintillaofArt2026/6.webp`;
    

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
        {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        }

    ];

    return (
         <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            
                            <Box >
                                <Typography variant='h4' align='center' >
                                    <div>Scintilla of Art  </div>
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                 Class: 10     Date: 25 September 2026, Friday
                                </Typography>
                             
                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
The Annual Art Exhibition, “Scintilla of Art” organised as part of the Sewa activity at National Public School, Yeshwanthpur, was formally inaugurated on Friday, 25 September 2026, by the Principal, Ms. Sheeja Manoj. The event marked the beginning of an inspiring showcase of creativity and enterprise, with the Class 10 students presenting a vibrant collection of their artistic and handmade creations.
                               <br></br>
The exhibition featured a delightful variety of colourful paintings, artistic creations, elegant jewellery, decorative pieces and other handmade products. Each stall reflected the students’ creativity, enthusiasm and meticulous effort, offering visitors an opportunity to appreciate and support their work.
                               <br></br>
One of the major attractions of the exhibition was the NPS Café, which was managed entirely by student teams. The café offered a tempting selection of chaats, sandwiches, juices, nachos, cupcakes, cookies, buttermilk and other wholesome refreshments. The café proved to be a popular attraction among the visitors (Teachers, Students) and added to the lively atmosphere of the exhibition.
                                    <br></br>
The exhibition was a resounding success, providing the young creators with a platform to showcase their artistic talents while developing their entrepreneurial and administrative skills. More importantly, the event reflected the spirit of Sewa, as the proceeds from the exhibition were to be donated to orphanages, giving the students’ creativity and the event a deeper purpose.
                                      <br></br>
                                </Typography>
                            </Box>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “AYURVEDA- THE ART OF MINDFUL LIVING ”

                                <br />
                            </Typography> */}
                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default ScintillaofArt2026;